import React from 'react'

const StaysData = () => {
  return (
    <div className='stays__data'>
        <h1 className='stays__location'>Stays in finland</h1>
        <span className='stays__count'>12+ stays</span>
    </div>
  )
}

export default StaysData